import Link from "@/components/ui/RouterLink";
import { ArrowUpRight } from "lucide-react";
import { productMegaMenu } from "@/config/navigation";
import { categoryIcon } from "@/components/ui/icon-map";

export function MegaMenu() {
  return (
    <div className="glass-panel absolute left-1/2 top-full mt-3 w-[640px] -translate-x-1/2 rounded-card p-6 shadow-2xl">
      <div className="grid grid-cols-3 gap-6">
        {productMegaMenu.map((group) => (
          <div key={group.heading}>
            <p className="mb-3 text-[11px] font-medium uppercase tracking-[0.14em] text-text-muted">
              {group.heading}
            </p>
            <ul className="space-y-1">
              {group.items.map((item) => {
                const Icon = categoryIcon[item.icon];
                return (
                  <li key={item.href}>
                    <Link
                      href={item.href}
                      className="focus-ring group flex items-start gap-3 rounded-lg p-2.5 transition hover:bg-navy-secondary"
                    >
                      <span className="mt-0.5 flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-md border border-border bg-navy-secondary text-cyan">
                        <Icon className="h-4 w-4" strokeWidth={1.6} />
                      </span>
                      <span className="flex-1">
                        <span className="flex items-center gap-1 text-sm font-medium text-text-primary">
                          {item.label}
                          <ArrowUpRight className="h-3 w-3 opacity-0 transition group-hover:opacity-100" />
                        </span>
                        <span className="mt-0.5 block text-xs leading-snug text-text-muted">
                          {item.description}
                        </span>
                      </span>
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
